import { useMutation } from 'react-query';

import { authorizedDelete } from '../authorizedApi';

export const useStopSharingSessionMutation = () => {
  return useMutation<any, Error, string>(
    async (sessionid: string) => {
      const shareSession = authorizedDelete(
        `/session/${sessionid}/sharing`
      );
      const response = await shareSession();
      const data = await response.json();

      return data.sessionsharingid;
    },
    {
      retry: false,
    }
  );
};
